// Bid documents (Samsung AU) print dates day-first: "1/12/2025" is 1 December.
// normaliseForInput falls back to JS Date parsing, which reads that as 12
// January — a silent wrong date on Valid From/To and Expected Close. Parse
// d/m/yyyy explicitly first; anything else keeps the shared behaviour.
export function normaliseBidDate(value) {
  const m = /^\s*(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})\s*$/.exec(String(value ?? ''))
  if (m) {
    const day = Number(m[1]), month = Number(m[2]), year = Number(m[3])
    const d = new Date(year, month - 1, day)
    if (d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day) {
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    }
    return String(value).trim()
  }
  // Anything else: the same rules as NSRequestView's normaliseForInput(v, 'date')
  // (kept dependency-free so this module never pulls in the PDF viewer).
  if (value === null || value === undefined || value === '') return ''
  const s = String(value).trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s
  const d = new Date(s)
  if (!isNaN(d)) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
  }
  return s
}
